
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BLOG_POSTS } from '../data';

export const BlogListing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white pb-20 md:pb-32 overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-[400px] md:h-[650px] flex items-center justify-center overflow-hidden mb-8 md:mb-12">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1501785888041-af3ef285b470?q=80&w=2000&auto=format&fit=crop" 
            className="w-full h-full object-cover brightness-[0.4] scale-105"
            alt="Blog Hero"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60"></div>
        </div>
        
        <div className="relative z-10 text-center px-4 w-full max-w-5xl">
          <div className="inline-block bg-brand-accent text-white px-5 py-2 rounded-lg text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] mb-6 md:mb-8 animate-fade-in shadow-xl">
            Atklājumi un stāsti
          </div>
          <h1 className="text-4xl md:text-7xl font-black mb-4 md:mb-6 text-white tracking-tighter leading-none animate-fade-in uppercase select-none">
            Mūsu <span className="text-brand-accent">Blogs</span>
          </h1>
          <div className="w-20 md:w-24 h-2 md:h-2.5 bg-brand-accent mx-auto mt-4 md:mt-6 rounded-full shadow-lg"></div>
        </div>
      </section>

      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12 text-left">
          {BLOG_POSTS.map(post => (
            <div 
              key={post.id} 
              onClick={() => navigate(`/blogs/${post.slug}`)}
              className="group cursor-pointer space-y-6 md:space-y-8"
            >
              <div className="relative h-[280px] md:h-[350px] rounded-xl overflow-hidden shadow-lg border-[6px] md:border-4 border-white group-hover:shadow-brand-deep/5 transition-all duration-500">
                <img 
                  src={post.image} 
                  alt={post.title} 
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                />
                <div className="absolute top-4 left-4 md:top-6 md:left-6 bg-white/95 backdrop-blur-md px-3 py-1.5 rounded-md text-[8px] md:text-[9px] font-black uppercase tracking-widest text-brand-accent shadow-lg">
                  {post.category}
                </div>
              </div>
              
              <div className="px-1 md:px-2">
                <div className="flex items-center gap-3 text-[8px] md:text-[9px] font-black uppercase tracking-[0.2em] text-brand-deep/30 mb-3 md:mb-4">
                  <span>{post.date}</span>
                  <span className="w-1 h-1 bg-brand-accent rounded-full"></span>
                  <span>{post.author}</span>
                </div>
                <h3 className="text-2xl md:text-3xl font-black text-brand-deep leading-tight md:leading-[1.2] tracking-tighter group-hover:text-brand-accent transition-colors mb-3 md:mb-4">
                  {post.title}
                </h3>
                <p className="text-brand-deep/80 text-sm md:text-base leading-relaxed font-medium line-clamp-2 mb-6 md:mb-8">
                  {post.excerpt}
                </p>
                <button className="flex items-center gap-3 md:gap-4 text-brand-accent font-black uppercase text-[9px] md:text-[10px] tracking-[0.2em] group-hover:gap-6 transition-all border-b-2 border-brand-accent pb-1">
                  Lasīt rakstu <i className="fas fa-arrow-right text-[9px]"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
